import CrossTenantBalance from '@/cross-tenant/CrossTenantBalance.vue'
import {registerRoute} from '@/router'
import {useContaCommand} from '@/commandbar/commandBar.service'
import {useBreadCrumbs} from '@/breadcrumbs/useBreadCrumbs'
import {NavGroup, registerNavigationEntry} from '@/navigation'

const {registerNavigationCommand} = useContaCommand()

const {buildSimpleCrumb} = useBreadCrumbs()
export const CROSS_TENANT_BALANCE = {
    componentName: 'CrossTenantBalance',
    component: CrossTenantBalance
}

registerRoute(CROSS_TENANT_BALANCE)
const label = 'Konsernavstemming'
const icon = 'i-ph-arrows-merge'
registerNavigationCommand({
    route: CROSS_TENANT_BALANCE,
    icon,
    label
})
registerNavigationEntry(NavGroup.REPORTS, {
    title: label,
    key: 'cross-tenant-balance',
    icon,
    target: CROSS_TENANT_BALANCE,
    sortOrder: 12
})
buildSimpleCrumb(CROSS_TENANT_BALANCE, label, icon, true)